module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bd-0ad8c443ef4d47ea04971830551cd03d.svg";